import React from 'react';
import { observer } from 'mobx-react-lite';
import { popupStore } from '@pascal/pascal-core';

import { wheelStore } from '../../store';
import { ResultCircles } from '../common';
import logoGame from '../../assets/images/game/logo-game.png';

export const ResultsHistory = observer(() => {
  const { popupToggle } = popupStore;
  const { wheelResultsHistory } = wheelStore;

  return (
    <div className='g-c-top-area-t'>
      <div className={`game-logo-wrp ${popupToggle ? 'is-popup-show' : ''}`}>
        <img src={logoGame} alt='' />
      </div>
      <div className='game-top-area-ins'>
        <div className='g-top-area-bl'>
          <div className='g-top-area-bl-in'>
            {wheelResultsHistory.map(({ color, id, anim = false }) => (
              <ResultCircles position={anim ? 'prev' : ''} key={id} color={color} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
});
